import { createReduxStore } from './store-creator';

export default createReduxStore();


// WEBPACK FOOTER //
// ./src/store/index.js